module.exports = __webpack_public_path__ + "img/FR12135.99663191.png";